module.exports = __webpack_public_path__ + "img/ded-stock-1.fb9238d8.png";